function currentDateIsNewer(oldDate) {
  const oldStoredDate = new Date(oldDate).getTime();
  const currentDateAsNumber = new Date().getTime();
  return currentDateAsNumber - oldStoredDate >= 0;
}

export default currentDateIsNewer;